import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../i18n/LanguageContext';
import { INSTAGRAM_URL } from '../constants/links';

import gallery01 from '../images/assets/images/527624345_773794932268384_2583182048620362363_n.jpg';
import gallery02 from '../images/assets/images/527882565_1306638564310529_240650376796672471_n.jpg';
import gallery03 from '../images/assets/images/531694852_2138934753265999_7705091226865957763_n.jpg';
import gallery04 from '../images/assets/images/619606938_18406279720127665_1193300022534230394_n.jpg';
import gallery05 from '../images/assets/images/619892616_18428643868116626_1272259002326119623_n.jpg';
import gallery06 from '../images/assets/images/624225364_18404200267126435_6066351499581116161_n.jpg';
import gallery07 from '../images/assets/images/625269153_18504604558077134_8193815127909181583_n.jpg';
import gallery08 from '../images/assets/images/628684041_18563765332045149_3955079873194431139_n.jpg';

const Gallery = () => {
  const { t } = useLanguage();

  const images = [
    gallery01,
    gallery02,
    gallery03,
    gallery04,
    gallery05,
    gallery06,
    gallery07,
    gallery08,
  ];

  return (
    <section className="py-24 bg-brand-cream">
      <div className="max-w-7xl mx-auto px-6 mb-12 flex justify-between items-end">
        <div>
          <h2 className="font-serif text-3xl md:text-4xl text-brand-dark mb-4">{t('gallery.title')}</h2>
          <p className="text-brand-muted font-light">{t('gallery.subtitle')}</p>
        </div>
        <a
          href={INSTAGRAM_URL}
          target="_blank"
          rel="noreferrer"
          className="hidden md:inline-block text-brand-taupe hover:text-brand-taupeDark uppercase tracking-widest text-sm font-medium transition-colors"
        >
          {t('gallery.handle')}
        </a>
      </div>

      <div className="w-full overflow-hidden">
        <div className="flex overflow-x-auto hide-scrollbar snap-x snap-mandatory pb-8 px-6 gap-6 md:grid md:grid-cols-4 md:gap-4 md:overflow-visible md:px-6 max-w-7xl mx-auto">
          {images.map((src, index) => (
            <motion.div 
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="flex-none w-[80vw] sm:w-[50vw] md:w-auto snap-center"
            >
              <div className="aspect-[4/5] rounded-2xl overflow-hidden">
                <img 
                  src={src} 
                  alt={t('gallery.imageAlt')}
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
                />
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
